import {API_URLS} from '@px/const/urls';
import {http} from '@px/helper/http';

export const tpsApi = {
  getOrderBookPerm() {
    return http.get(API_URLS.ORDER_BOOK_PERM, {});
  },
  orderBookAdjust(params) {
    return http.post(API_URLS.ORDER_BOOK_ADJUST, {params});
  },
};
